import { render, staticRenderFns } from "./RegionModal.vue?vue&type=template&id=bbf284de"
import script from "./RegionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports